import { Link, useLocation } from "react-router-dom";
import { Home, CirclePlus, ReceiptText, UserRound } from "lucide-react";
import { useAuth } from "../context/AuthProvider";

export default function MobileBottomNav() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  const accountPath = (path: string) => user ? path : `/login?next=${encodeURIComponent(path)}`;
  const items = [
    { label: "홈", icon: Home, to: "/m/home", active: ["/", "/m/home"].includes(pathname) },
    { label: "결제등록", icon: CirclePlus, to: "/registration", active: pathname === "/registration" || pathname.startsWith("/contracts/") },
    { label: "이용목록", icon: ReceiptText, to: accountPath("/pay"), active: pathname === "/pay" },
    { label: "마이페이지", icon: UserRound, to: accountPath("/mypage"), active: ["/my", "/mypage", "/dashboard"].includes(pathname) },
  ];
  return <nav className="jp-bottom-nav" aria-label="하단 주요 메뉴"><div>
    {items.map(({ label, icon: Icon, to, active }) => <Link key={label} to={to} aria-current={active ? "page" : undefined}>
      <Icon size={22} strokeWidth={active ? 2 : 1.6} aria-hidden="true" /><span>{label}</span>
    </Link>)}
  </div></nav>;
}
